import { useState } from "react";
import "./DeleteClinicalHistoryModal.css";

import { useAppContext } from "../../../../classes/contexts/AppContext";
import { useNotification } from "../../../../classes/contexts/NotificationContext";
import IconsEnum from "../../../../classes/enums/IconsEnum";
import { SnackbarType } from "../../../../classes/enums/SnackbarTypeEnum";
import Button from "../../../../components/button/Button";
import WarningIcon from "../../../../components/icons/WarningIcon";
import IconButton from "../../../../components/iconButton/IconButton";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import { deleteClinicalHistory } from "../../../../services/ClinicalHistoryService";

const DeleteClinicalHistoryModal = ({ history, onHistoryDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslation();
  const { hidePopup } = useAppContext();
  const { addNotification } = useNotification();

  const handleConfirm = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      await deleteClinicalHistory(history._id);
      if (onHistoryDeleted) {
        await onHistoryDeleted();
      }
      hidePopup();
    } catch (error) {
      addNotification(SnackbarType.ERROR, error.message);
      setIsDeleting(false);
    }
  };

  const handleClose = () => {
    if (!isDeleting) hidePopup();
  };

  return (
    <div className="App-module-delete-clinical-history-modal-container">
      <div className="App-module-delete-clinical-history-modal-close">
        <IconButton
          icon={IconsEnum.CLOSE}
          onClick={handleClose}
          noBgColor={true}
          disabled={isDeleting}
          title={t("43")}
        />
      </div>
      <div className="App-module-delete-clinical-history-modal-header">
        <WarningIcon />
        <h2>Delete Medical History</h2>
      </div>
      <div className="App-module-delete-clinical-history-modal-body">
        <p className="confirmation-question">
          Are you sure you want to delete this medical history?
        </p>
      </div>
      <div className="App-module-delete-clinical-history-modal-actions">
        <Button
          value={t("4")}
          disabled={isDeleting}
          onClick={handleConfirm}
          className="delete-button"
        />
      </div>
    </div>
  );
};

export default DeleteClinicalHistoryModal;
